class CountdownTimer extends HTMLElement {

  connectedCallback() {
    this.setupTimer();
    document.addEventListener('shopify:section:load', event => {
      if (event.detail.sectionId === this.getAttribute('data-section-id')) {
        this.setupTimer();
      }
    });
  }

  setupTimer() {
    clearInterval(this.timer); // Clear existing timer if any
    this.endDate = new Date(this.getAttribute('data-datetime')).getTime();
    this.hideWhenFinished = this.getAttribute('data-hide-when-finished') === 'true';
    this.showWithinHour = this.getAttribute('data-show-within-hour') === 'true';
    this.countToClosing = this.getAttribute('data-count-to-closing') === 'true';
    this.openClosed = this.getAttribute('data-open-closed');
    this.timer = setInterval(() => this.updateTimer(), 1000);
    this.updateTimer();
  }

  updateTimer() {
    const now = Date.now();
    const secondsRemaining = (this.openClosed == 'closed' && this.countToClosing ) ? 0 : Math.max(0, Math.ceil((this.endDate - now) / 1000));
    const section = this.closest('section');

    if (this.hideWhenFinished && secondsRemaining === 0) {
      clearInterval(this.timer);
      section.style.display = 'none';
    }

    if (this.showWithinHour && (secondsRemaining > 3600 || secondsRemaining < 0)) {
      section.style.display = 'none';
    }

    const days = Math.floor(secondsRemaining / 86400);
    const hours = Math.floor((secondsRemaining % 86400) / 3600);
    const minutes = Math.floor((secondsRemaining % 3600) / 60);
    const seconds = secondsRemaining % 60;

    this.querySelector('.days').textContent = days.toString().padStart(2, '0');
    this.querySelector('.hours').textContent = hours.toString().padStart(2, '0');
    this.querySelector('.minutes').textContent = minutes.toString().padStart(2, '0');
    this.querySelector('.seconds').textContent = seconds.toString().padStart(2, '0');

    if (days === 0) {
      this.querySelector('.days__wrapper').style.display = 'none';
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

customElements.define('countdown-timer', CountdownTimer);
